import { useTranslation } from 'react-i18next';

export const keyPrefix = 'detection_overlay';
export const useDetectionOverlayTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    size: 'Размер',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    size: 'Size',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    size: 'Tamanho',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    size: 'Tamaño',
  },
}) as Record<string, unknown>;
